import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import styled, { keyframes } from 'styled-components';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { Box } from '../Box/index.js';

const slideDown = keyframes(["from{height:0;overflow:hidden;}99%{height:var(--radix-collapsible-content-height);overflow:hidden;}to{height:100%;}"]);
const slideUp = keyframes(["from{height:var(--radix-collapsible-content-height);}to{height:0;}"]);
const StyledPanel = styled(AccordionPrimitive.Content).withConfig({
  displayName: "AccordionPanel__StyledPanel",
  componentId: "sc-1ixy9sy-0"
})(["&[data-state='open']{animation:", " 300ms ease forwards;}&[data-state='closed']{overflow:hidden;animation:", " 300ms ease forwards;}"], slideDown, slideUp);
/**
 * AccordionPanel contains the collapsible content for an item.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/accordion#usage)
 * - [Props](https://blockparty.endpoint.com/components/accordion#props)
 * <br />
 *
 */
const AccordionPanel = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    hideDivider = false,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledPanel, null, /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    bg: "background",
    borderBottomLeftRadius: "radiusDefault",
    borderBottomRightRadius: "radiusDefault",
    borderTop: hideDivider ? 'initial' : '1px solid',
    borderTopColor: "divider",
    "data-test-id": "accordion-panel",
    fontSize: "fontSize20",
    lineHeight: "lineHeight20",
    px: "space30",
    py: "space50"
  }, props), children));
});
AccordionPanel.displayName = 'AccordionPanel';

export { AccordionPanel };
